import React from "react";
import { BaseCompany } from "../../../interfaces/data";
import { Input } from "../../../components/Input/Input";
import { TwoColumnsLayout } from "../../../components/TwoColumnsLayout/TwoColumnsLayout";
import { useTranslation } from "react-i18next";
import { EditViewProps } from "../../../components/EditBox/EditBox";
import { Select } from "../../../components/Select/Select";
import { COUNTRIES } from "../../../helpers/options";

export function EditContactAddress({ data, handleChange, errors }: EditViewProps<BaseCompany>) {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <TwoColumnsLayout>
      <Input
        error={errors?.["contactAddress.street"]}
        id="street"
        label={t("company:Street")}
        name="contactAddress.street"
        onChange={handleChange}
        type="text"
        value={data.contactAddress?.street}
        withError={errors && !!errors["contactAddress.street"]}
      />
      <Input
        error={errors?.["contactAddress.number"]}
        id="number"
        label={t("company:Apt number")}
        name="contactAddress.number"
        onChange={handleChange}
        type="text"
        value={data.contactAddress?.number}
        withError={errors && !!errors["contactAddress.number"]}
      />
      <Input
        error={errors?.["contactAddress.code"]}
        id="code"
        label={t("company:Code")}
        name="contactAddress.code"
        onChange={handleChange}
        type="text"
        value={data.contactAddress?.code}
        withError={!!errors?.["contactAddress.code"]}
      />
      <Input
        error={errors?.["contactAddress.city"]}
        id="city"
        label={t("company:City")}
        name="contactAddress.city"
        onChange={handleChange}
        type="text"
        value={data.contactAddress?.city}
        withError={errors && !!errors["contactAddress.city"]}
      />
      <Select
        error={errors?.["contactAddress.country"]}
        id="country"
        label={t("company:Country")}
        name="contactAddress.country"
        onChange={handleChange}
        options={COUNTRIES}
        value={data.contactAddress?.country}
      />
    </TwoColumnsLayout>
  );
}
